import { useEffect, useRef } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { useAuth } from "@/stores/auth";
import { cartKeys, mergeGuestCart } from "./api";

/**
 * Keeps the cart in step with the session: when someone signs in, their guest cart (keyed by this
 * browser's session id) is merged into the account; when they sign out, the cached cart is dropped.
 */
export function CartSync() {
  const status = useAuth((s) => s.status);
  const userId = useAuth((s) => s.user?.id);
  const qc = useQueryClient();
  const previous = useRef(status);

  useEffect(() => {
    const was = previous.current;
    previous.current = status;
    if (status === "authenticated" && was !== "authenticated") {
      mergeGuestCart()
        .then((cart) => qc.setQueryData(cartKeys.cart, cart))
        .catch(() => qc.invalidateQueries({ queryKey: cartKeys.cart }));
      void qc.invalidateQueries({ queryKey: ["wishlist"] });
    }
    if (status === "anonymous" && was === "authenticated") {
      qc.removeQueries({ queryKey: cartKeys.cart });
      qc.removeQueries({ queryKey: ["wishlist"] });
      qc.removeQueries({ queryKey: ["orders"] });
      qc.removeQueries({ queryKey: ["wallet"] });
    }
  }, [status, userId, qc]);
  return null;
}
